import { styledFactory } from '@trmediaab/zebra';
import type * as CSS from 'csstype';
import { Component } from 'react';
import type { ObjectOrArray, SpaceProps } from 'styled-system';

export interface StyledIconProps {
  size?: SpaceProps;
  width?: ObjectOrArray<CSS.Property.Width<{}>>;
  height?: ObjectOrArray<CSS.Property.Width<{}>>;
}

export default function createStyledIcon<P, C>(
  WrappedIcon: React.JSXElementConstructor<P> & C & { displayName?: string },
  title?: '',
  defaultProps?: P,
): any /* TODO */ {
  type Props = React.JSX.LibraryManagedAttributes<C, P & StyledIconProps>;

  class SystemIcon extends Component<Props, never> {
    static displayName = `styledIcon(${
      WrappedIcon.displayName || WrappedIcon.name || 'Icon'
    })`;

    render() {
      const { size, width, height, ...props } = this.props;
      return (
        <WrappedIcon title={title} {...defaultProps} {...(props as any)} />
      );
    }
  }

  return styledFactory<Props, typeof SystemIcon>(SystemIcon, 'Icon');
}
